import { styled } from "@acko-tech/building-blocks.ui.common";

export const CardWrapper = styled.div`
  border-radius: 24px;
  border: 1px solid var(--Border-Default-grey100, #e8e8e8);
  background: #fff;
  padding: 32px 20px 24px 20px;
  @media (min-width: 768px) {
    border-radius: 40px;
  }
`;

export const HeaderSection = styled.div`
  color: var(--Yellow-Y500, #d16900);
  text-align: center;
  font-family: "Euclid Circular B";
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
  @media (min-width: 768px) {
    color: var(--Yellow-Y500, #d16900);
    text-align: center;
    font-family: "Euclid Circular B";
    font-size: 22px;
    font-style: normal;
    font-weight: 600;
    line-height: 34px;
    letter-spacing: -0.1px;
  }
`;

export const HeaderNumber = styled.div`
  color: var(--Yellow-Y500, #d16900);
  text-align: center;
  font-family: "Euclid Circular B";
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
  @media (min-width: 768px) {
    color: var(--Yellow-Y500, #d16900);
    text-align: center;
    font-family: "Euclid Circular B";
    font-size: 22px;
    font-style: normal;
    font-weight: 600;
    line-height: 34px;
    letter-spacing: -0.1px;
  }
`;

export const HeaderQuote = styled.div`
  color: var(--Yellow-Y500, #d16900);
  text-align: center;
  font-family: "Euclid Circular B";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  @media (min-width: 768px) {
    color: var(--Yellow-Y500, #d16900);
    text-align: center;
    font-family: "Euclid Circular B";
    font-size: 22px;
    font-style: normal;
    font-weight: 600;
    line-height: 34px;
    letter-spacing: -0.1px;
  }
`;

export const Divider = styled.div`
  height: 1px;
  border-top: 1px dashed var(--Border-Default-grey100, #e8e8e8);
  margin: 16px 0px;
`;

export const ContentBox = styled.div`
  border-radius: 8.513px;
  border: 0.532px solid rgba(10, 10, 10, 0.08);
  background: #f8f3ec;
  box-shadow: 0 4.256px 12.769px -4.256px rgba(10, 10, 10, 0.08);
  padding: 16px;
  @media (min-width: 768px) {
    padding: 24px;
  }
`;

export const MainText = styled.div`
  color: var(--Green-G500, #064625);
  text-align: center;
  font-family: "Times New Roman", Times, serif !important;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 23.41px;
  letter-spacing: -0.053px;
  @media (min-width: 768px) {
    color: var(--Green-G500, #064625);
    text-align: center;
    font-family: "Times New Roman";
    font-size: 32.184px;
    font-style: normal;
    font-weight: 700;
    line-height: 37.671px; /* 117.049% */
    letter-spacing: -0.086px;
  }
`;

export const ContentDivider = styled.div`
  height: 2px;
  border-top: 2px dashed var(--Border-Default-grey100, #e8e8e8);
  margin: 16px 0px;
`;

export const SubText = styled.div`
  color: var(--text-primary-n-600, #040222);
  text-align: center;
  font-family: "Times New Roman";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  @media (min-width: 768px) {
    color: var(--text-primary-n-600, #040222);
    font-family: "Times New Roman", Times, serif !important;
    font-size: 22.529px;
    font-style: normal;
    font-weight: 400;
    line-height: 32.184px; /* 142.857% */
  }

  Linktext {
    color: var(--text-primary-n-600, #040222);
    font-family: "Times New Roman", Times, serif !important;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    text-underline-position: from-font;
    cursor: pointer;
    @media (min-width: 768px) {
      color: var(--text-primary-n-600, #040222);
      font-family: "Times New Roman", Times, serif !important;
      font-size: 22px;
      font-style: normal;
      font-weight: 700;
      line-height: 32.184px;
      text-decoration-line: underline;
      text-decoration-style: solid;
      text-decoration-skip-ink: none;
      text-decoration-thickness: auto;
      text-underline-offset: auto;
      text-underline-position: from-font;
    }
  }
`;


